import { MainStepOptions } from './MainStepOptions';
import { BaseStepsConfigurations } from './BaseStepsConfigurations';

export class MainStepsConfigurations extends BaseStepsConfigurations {
  steps: MainStepOptions[];
  showForwardArrow: boolean;
}
